import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {

    },
    actions: {
        fetchAll(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/sites', { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        fetch(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/sites/' + payload.site_id)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        siteStore(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/sites/store',  payload)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        fetchAvitoCities(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/avito-cities', { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        fetchAvitoAreas(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/avito-areas', { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        storeAvitoCity(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/avito-cities', payload)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        updateAvitoCity(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/avito-cities/${payload.id}`, payload)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        deleteAvitoCity(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/avito-cities/${payload.id}`)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        storeAvitoArea(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/avito-areas', payload)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        updateAvitoArea(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/avito-areas/${payload.id}`, payload)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        deleteAvitoArea(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/avito-areas/${payload.id}`)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
    },
}
